export default "__VITE_ASSET__DVIIYBe7__"